import { CommonData } from '../common_schema'

export const threadCPUData: CommonData[] = [
  {
    name: 'Unified Read Pool CPU',
    mean: 'unified_read_pool_cpu_avg:total.values.mean',
    std: 'unified_read_pool_cpu_avg:total.values.std',
    location: 'TiKV-Details --> Thread CPU --> Unified Read Pool CPU'
  },
  {
    name: 'GC worker CPU',
    mean: 'gc_worker_cpu_avg:total.values.mean',
    std: 'gc_worker_cpu_avg:total.values.std',
    location: 'TiKV-Details --> Thread CPU --> GC worker CPU'
  },
  {
    name: 'Raft store CPU',
    mean: 'raftstore_cpu_avg:total.values.mean',
    std: 'raftstore_cpu_avg:total.values.std',
    location: 'TiKV-Details --> Thread CPU --> Raft store CPU'
  },
  {
    name: 'Async apply CPU',
    mean: 'async_apply_cpu_avg:total.values.mean',
    std: 'async_apply_cpu_avg:total.values.std',
    location: 'TiKV-Details --> Thread CPU --> Async apply CPU'
  },
  {
    name: 'Scheduler worker CPU',
    mean: 'scheduler_worker_cpu_avg:total.values.mean',
    std: 'scheduler_worker_cpu_avg:total.values.std',
    location: 'TiKV-Details --> Thread CPU --> Scheduler worker CPU'
  },
  {
    name: 'gRPC Pool CPU',
    mean: 'grpc_pool_cpu_avg:total.values.mean',
    std: 'grpc_pool_cpu_avg:total.values.std',
    location: 'TiKV-Details --> Thread CPU --> gRPC Pool CPU'
  },
  {
    name: 'RocksDB CPU',
    mean: 'rocksdb_cpu_avg:total.values.mean',
    std: 'rocksdb_cpu_avg:total.values.std',
    location: 'TiKV-Details --> Thread CPU --> RocksDB CPU'
  },
  {
    name: 'BackGround Worker CPU',
    mean: 'background_worker_cpu_avg:total.values.mean',
    std: 'background_worker_cpu_avg:total.values.std',
    location: 'TiKV-Details --> Thread CPU --> BackGround Worker CPU'
  },
  {
    name: 'Backup Worker CPU',
    mean: 'backup_worker_cpu_avg:total.values.mean',
    std: 'backup_worker_cpu_avg:total.values.std',
    location: 'TiKV-Details --> Thread CPU --> Backup Worker CPU'
  }
]
